<script setup lang="ts">
import StatusPing from "@/components/custom/StatusPing.vue"

defineProps<{
  price?: string
  name: string
  type?: string
  situational?: boolean
  status?: "pending" | "approved" | "rejected"
}>()
</script>

<template>
  <div
    class="border-border relative flex h-full cursor-help flex-col items-start rounded-sm border p-4.5"
  >
    <StatusPing
      v-show="status"
      :status="status"
      class="absolute top-4 right-4"
    />
    <div
      v-if="$slots.icon"
      class="text-primary flex size-10 items-center justify-center rounded-sm bg-[#EEF1FB]"
    >
      <slot name="icon" class="size-9" />
    </div>
    <p v-if="price" class="text-primary mt-6 text-3xl font-medium">
      {{ price }}<span class="text-base">€/mes</span>
    </p>
    <p
      class="mt-2.5 text-left text-lg leading-6 font-bold whitespace-pre-line opacity-80"
    >
      {{ name }}
    </p>
    <p v-if="type" class="text-muted-foreground text-sm">{{ type }}</p>
  </div>
</template>
